module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }